import { AppBox, AppText } from "../../../../../commons/components";
export default function MatchCommentaryDeleteInprogress() {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>Deleting Commentary In Progress</AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
